import React from "react";

import { Box, Tabs, Tab } from "@mui/material";

export const SearchType = ({handleTabChange, tabValue}) => {
  return (
    <Box 
      sx={{ borderBottom: 1, borderColor: 'divider' }}
      textColor="secondary"
      indicatorColor="secondary"
      >
      <Tabs value={tabValue} onChange={handleTabChange} aria-label="search type">
        <Tab label="Edupix" value={0}/>
        <Tab label="GDL" value={1}/>
      </Tabs>
    </Box>
  )
}

export default SearchType;